import { Box, Typography } from '@mui/material';

import { Localized } from 'dg-web-shared/lib/Localization';
import { ParkingaboLink } from 'parkingabo-shared/layout/ParkinaboLink.tsx';
import { envIsProduction } from 'dg-web-shared/lib/Environment.ts';

interface ParkingaboHeaderProps {
    to?: string;
    linkLabel?: React.ReactNode | string;
    onLinkClick?: () => void;
}

export function ParkingaboHeader({
    to,
    linkLabel,
    onLinkClick,
}: ParkingaboHeaderProps) {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: to ? 'space-between' : 'flex-end',
                alignItems: 'center',
                backgroundColor: envIsProduction()
                    ? undefined
                    : theme => theme.palette.warning.light,
            }}
        >
            {to && (
                <ParkingaboLink to={to} onClick={onLinkClick}>
                    {linkLabel}
                </ParkingaboLink>
            )}
            <Typography variant="h2">
                <Localized
                    de="Parkingabo"
                    fr="Parkingabo"
                    it="Parkingabo"
                    en="Parkingabo"
                />
            </Typography>
        </Box>
    );
}
